import { useState, useEffect } from 'react';
import styled from 'foundations-theming/utils';
import withTheme from 'ContentComponents/components/cmv2/decorators/withTheme';
import usePrevious from 'react-utils/hooks/usePrevious';
import { Table } from 'foundations-components/transitional/components/Table';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import FormWorkflowDependenciesTableRow from 'ContentComponents/components/cmv2/form/formAutomation/connectedWorkflows/FormWorkflowDependenciesTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROWS_PER_PAGE = 5;
const ExtraTableRow = styled.tr.withConfig({
  displayName: "FormWorkflowDependenciesTable__ExtraTableRow",
  componentId: "wcda7e-0"
})(({
  isBlank,
  theme
}) => {
  return isBlank ? `
    td {
      border-width: ${theme.borderWidth['0']};
    }
  ` : '';
});
const FormWorkflowDependenciesTable = ({
  contentId,
  formGuid,
  formWorkflowDependencies,
  hasWorkflowsAppAccess,
  hasWorkflowsDeleteAccess,
  onEditWorkflowEvent,
  onRemoveWorkflowEvent,
  readOnly,
  seleniumKey
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const prevNumberOfWorkflows = usePrevious(formWorkflowDependencies.length) || 0;
  const numberOfWorkflows = formWorkflowDependencies.length;
  useEffect(() => {
    if (prevNumberOfWorkflows > numberOfWorkflows && currentPage > 0 && currentPage * ROWS_PER_PAGE >= numberOfWorkflows) {
      setCurrentPage(Math.ceil(numberOfWorkflows / ROWS_PER_PAGE) - 1);
    }
  }, [prevNumberOfWorkflows, numberOfWorkflows, currentPage]);
  const firstIndex = currentPage * ROWS_PER_PAGE;
  const pageCount = Math.ceil(formWorkflowDependencies.length / ROWS_PER_PAGE);
  const hasPagination = pageCount > 1;
  const rowsToRender = formWorkflowDependencies.slice(firstIndex, firstIndex + ROWS_PER_PAGE);

  // If paginated, pad with extra rows if needed to keep the table
  // the same height for each page
  let extraRows = [];
  if (hasPagination && rowsToRender.length < ROWS_PER_PAGE) {
    extraRows = [...Array(ROWS_PER_PAGE - rowsToRender.length).keys()].map(i => /*#__PURE__*/_jsx(ExtraTableRow, {
      isBlank: i > 0,
      children: /*#__PURE__*/_jsx("td", {})
    }, i));
  }
  return /*#__PURE__*/_jsx(Table, {
    "data-selenium": seleniumKey,
    hover: false,
    responsive: false,
    marginBlock: "200",
    children: /*#__PURE__*/_jsxs("tbody", {
      children: [rowsToRender.map(formWorkflowDependency => {
        return /*#__PURE__*/_jsx(FormWorkflowDependenciesTableRow, {
          contentId: contentId,
          formGuid: formGuid,
          formWorkflowDependency: formWorkflowDependency,
          hasWorkflowsAppAccess: hasWorkflowsAppAccess,
          hasWorkflowsDeleteAccess: hasWorkflowsDeleteAccess,
          onEditWorkflowEvent: onEditWorkflowEvent,
          onRemoveWorkflowEvent: onRemoveWorkflowEvent,
          readOnly: readOnly
        }, formWorkflowDependency.flowId);
      }), extraRows, hasPagination && /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(Paginator, {
            maxVisiblePageButtons: 3,
            onPageChange: ({
              target: {
                value
              }
            }) => setCurrentPage(value - 1),
            page: currentPage + 1,
            pageCount: pageCount
          })
        })
      })]
    })
  });
};
export default withTheme(FormWorkflowDependenciesTable);